export const LOCALE_KEY = 'app-locale';

export const LOCALE_EN = 'en';
export const LOCALE_FI = 'fi';
export const LOCALE_VI = 'vi';

export type Locale = 'en' | 'fi' | 'vi';
export const LOCALES: Locale[] = [
    LOCALE_EN,
    LOCALE_FI,
    LOCALE_VI,
];
